export default "__VITE_ASSET__eff591a5__"